module.exports = __webpack_public_path__ + "img/review-incomplete.bb757cda.svg";